/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { UpdateInquiryMutation, UpdateInquiryMutationVariables } from "@models/graphql";

export const useUpdateInquiry = (options?: MutationHookOptions<UpdateInquiryMutation, UpdateInquiryMutationVariables>) => useMutation<UpdateInquiryMutation, UpdateInquiryMutationVariables>(GraphQLDocuments.updateInquiry);
